import React from 'react';
import { Button } from '../components/Button';
const CORE_ERRORS = [
    'general',
    'cutoff_date',
    'has_additional_insureds',
    'has_insurance_losses',
];
export const Sidebar = (props) => {
    const { quote, loading, hasSubmitted, quickQuotable, errors } = props;
    return (React.createElement("div", { className: "sidebar" },
        React.createElement("h2", null, "Automated Quote"),
        loading && React.createElement("p", null, "Loading..."),
        !hasSubmitted && !loading && (React.createElement("p", null, "Fill in the fields in the Quote section to receive a Quick Quote.")),
        !quote && !quickQuotable && !loading && (React.createElement("p", null, "A Quick Quote is not available for this type of exposure. Continue with the application and an underwriter will review and contact you with an alternate quote if available.")),
        errors.length > 0 && !loading && (React.createElement(React.Fragment, null,
            React.createElement("h3", { className: "sidebar__error" }, "Errors"),
            React.createElement("ul", null, errors.map((e) => {
                return (React.createElement("li", { className: "sidebar__error", key: e.field },
                    !CORE_ERRORS.includes(e.field) && React.createElement(React.Fragment, null,
                        e.label,
                        " - "),
                    e.messages.join(', ')));
            })))),
        quote && quickQuotable && !loading && (React.createElement(React.Fragment, null,
            React.createElement("h3", null, "Pricing"),
            React.createElement("table", { className: "sidebar__quote" },
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null, "Premium"),
                        React.createElement("td", null, quote.premium)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Admin Fee"),
                        React.createElement("td", null, quote.administrative_fee)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Total"),
                        React.createElement("td", null, quote.total)))),
            React.createElement("h3", null, "Coverages"),
            React.createElement("table", { className: "sidebar__quote" },
                React.createElement("tbody", null, quote.coverages.map((c) => {
                    return (React.createElement("tr", { key: c.name },
                        React.createElement("td", null, c.name),
                        React.createElement("td", null, c.value)));
                }))))),
        props.onSubmit && !loading && (React.createElement(Button, { className: "button--full button--spacing", onClick: props.onSubmit }, "Continue")),
        props.onContinue && !loading && (React.createElement(Button, { className: "button--full button--spacing", onClick: props.onContinue, testId: "apply-for-purchase-continue" },
            quickQuotable && (React.createElement(React.Fragment, null,
                "Apply for and purchase coverage",
                React.createElement("br", null),
                "continue")),
            !quickQuotable && React.createElement(React.Fragment, null, "Continue to apply for coverage")))));
};
